function buildAddToCartFeedback(button) {
  if (!button || button.dataset.atcFeedbackReady === "true") return;
  if (!button.classList.contains("button-add-to-cart")) return;

  button.dataset.atcFeedbackReady = "true";
  button.setAttribute("data-atc-feedback", "true");

  const overlay = document.createElement("span");
  overlay.className = "button-atc-feedback";
  overlay.setAttribute("aria-hidden", "true");
  overlay.innerHTML = `
    <span class="button-atc-feedback__check">✓</span>
    <span class="button-atc-feedback__text">Added</span>
  `.trim();
  button.appendChild(overlay);
}

function clearAddToCartState(button) {
  if (!button) return;
  button.classList.remove("atc-loading", "atc-success", "atc-error", "loading");
  button.removeAttribute("aria-disabled");
}

function setAddToCartState(button, state) {
  if (!button) return;

  button.classList.remove("atc-loading", "atc-success", "atc-error", "loading");
  const feedbackText = button.querySelector(".button-atc-feedback__text");
  const feedbackCheck = button.querySelector(".button-atc-feedback__check");

  if (!state) {
    if (feedbackText) feedbackText.textContent = "Added";
    if (feedbackCheck) feedbackCheck.hidden = false;
    button.removeAttribute("aria-disabled");
    return;
  }

  if (state === "atc-error") {
    if (feedbackText) feedbackText.textContent = "Try again";
    if (feedbackCheck) feedbackCheck.hidden = true;
  } else {
    if (feedbackText) feedbackText.textContent = "Added";
    if (feedbackCheck) feedbackCheck.hidden = false;
  }

  button.classList.add(state);
  button.setAttribute("aria-disabled", "true");
}

function serializeProductFormPayload(form) {
  return {
    ...JSON.parse(serializeForm(form)),
    sections_url: window.location.pathname,
  };
}

function postProductForm(payload) {
  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  config.body = JSON.stringify(payload);
  return fetch(`${routes.cart_add_url}`, config).then((response) => response.json());
}

class MobileVariantSheet {
  constructor() {
    this.productCache = new Map();
    this.activeForm = null;
    this.product = null;
    this.media = [];
    this.variants = [];
    this.optionNames = [];
    this.optionValues = [];
    this.selectedOptions = [];
    this.selectedVariant = null;
    this.sizeOptionIndex = -1;
    this.isAdding = false;
    this.currentOpenHandle = "";
    this.manualMediaSrc = "";

    this.overlay = null;
    this.sheet = null;
    this.titleElement = null;
    this.priceElement = null;
    this.priceCurrentElement = null;
    this.priceCompareElement = null;
    this.mediaSectionElement = null;
    this.mediaMainElement = null;
    this.mediaThumbsElement = null;
    this.bodyElement = null;
    this.optionsElement = null;
    this.messageElement = null;
    this.addButton = null;

    this.swipeTouchId = null;
    this.swipeStartY = 0;
    this.swipeCurrentY = 0;
    this.swipeStartAt = 0;
    this.isSwiping = false;
    this.swipeCloseThresholdPx = 96;
    this.swipeCloseVelocityThreshold = 0.45;
  }

  ensureMounted() {
    if (this.overlay && this.sheet) return;

    this.overlay = document.createElement("div");
    this.overlay.className = "mobile-variant-sheet-overlay";

    this.sheet = document.createElement("section");
    this.sheet.className = "mobile-variant-sheet";
    this.sheet.setAttribute("role", "dialog");
    this.sheet.setAttribute("aria-modal", "true");
    this.sheet.setAttribute("aria-hidden", "true");
    this.sheet.setAttribute("aria-label", "Select product options");

    this.sheet.innerHTML = `
      <div class="mobile-variant-sheet__grabber" aria-hidden="true"></div>
      <header class="mobile-variant-sheet__header">
        <div class="mobile-variant-sheet__title-wrap">
          <p class="mobile-variant-sheet__eyebrow">Quick add</p>
          <h3 class="mobile-variant-sheet__title"></h3>
          <p class="mobile-variant-sheet__price">
            <span class="mobile-variant-sheet__price-current"></span>
            <span class="mobile-variant-sheet__price-compare" hidden></span>
          </p>
        </div>
        <button type="button" class="mobile-variant-sheet__close" aria-label="Close">×</button>
      </header>
      <div class="mobile-variant-sheet__body">
        <section class="mobile-variant-sheet__media" aria-label="Product images">
          <figure class="mobile-variant-sheet__main-media">
            <img class="mobile-variant-sheet__main-image" alt="" loading="lazy">
          </figure>
          <div class="mobile-variant-sheet__thumbs" role="list"></div>
        </section>
        <div class="mobile-variant-sheet__options"></div>
        <p class="mobile-variant-sheet__message" hidden></p>
      </div>
      <footer class="mobile-variant-sheet__footer">
        <button type="button" class="mobile-variant-sheet__add button button--primary" disabled>Add to cart</button>
      </footer>
    `.trim();

    this.titleElement = this.sheet.querySelector(".mobile-variant-sheet__title");
    this.priceElement = this.sheet.querySelector(".mobile-variant-sheet__price");
    this.priceCurrentElement = this.sheet.querySelector(".mobile-variant-sheet__price-current");
    this.priceCompareElement = this.sheet.querySelector(".mobile-variant-sheet__price-compare");
    this.mediaSectionElement = this.sheet.querySelector(".mobile-variant-sheet__media");
    this.mediaMainElement = this.sheet.querySelector(".mobile-variant-sheet__main-image");
    this.mediaThumbsElement = this.sheet.querySelector(".mobile-variant-sheet__thumbs");
    this.bodyElement = this.sheet.querySelector(".mobile-variant-sheet__body");
    this.optionsElement = this.sheet.querySelector(".mobile-variant-sheet__options");
    this.messageElement = this.sheet.querySelector(".mobile-variant-sheet__message");
    this.addButton = this.sheet.querySelector(".mobile-variant-sheet__add");

    const closeButton = this.sheet.querySelector(".mobile-variant-sheet__close");

    this.overlay.addEventListener("click", () => this.close());
    closeButton.addEventListener("click", () => this.close());
    this.addButton.addEventListener("click", () => this.handleAddToCart());
    this.sheet.addEventListener("touchstart", (event) => this.handleSwipeStart(event), {
      passive: true,
    });
    this.sheet.addEventListener("touchmove", (event) => this.handleSwipeMove(event), {
      passive: false,
    });
    this.sheet.addEventListener("touchend", (event) => this.handleSwipeEnd(event), {
      passive: true,
    });
    this.sheet.addEventListener("touchcancel", (event) => this.handleSwipeEnd(event), {
      passive: true,
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && document.body.classList.contains("mobile-variant-sheet-open")) {
        this.close();
      }
    });

    document.body.appendChild(this.overlay);
    document.body.appendChild(this.sheet);
  }

  isOpen() {
    return document.body.classList.contains("mobile-variant-sheet-open");
  }

  getTrackedTouch(touchList) {
    if (this.swipeTouchId == null || !touchList) return null;
    for (let i = 0; i < touchList.length; i += 1) {
      if (touchList[i].identifier === this.swipeTouchId) {
        return touchList[i];
      }
    }
    return null;
  }

  resetSwipeState() {
    this.swipeTouchId = null;
    this.swipeStartY = 0;
    this.swipeCurrentY = 0;
    this.swipeStartAt = 0;
    this.isSwiping = false;
  }

  clearSwipeStyles() {
    if (!this.sheet) return;
    this.sheet.style.transform = "";
    this.sheet.style.opacity = "";
    this.sheet.style.transition = "";
  }

  canStartSwipe(event, touch) {
    if (!window.matchMedia("(max-width: 749px)").matches) return false;
    if (!this.isOpen()) return false;

    const target = event.target;
    if (this.bodyElement && target instanceof Element && this.bodyElement.contains(target)) {
      if (this.bodyElement.scrollTop > 4) return false;
      const panelRect = this.sheet.getBoundingClientRect();
      if (touch.clientY > panelRect.top + 120) return false;
    }

    return true;
  }

  handleSwipeStart(event) {
    if (!event.touches || event.touches.length !== 1) return;
    const touch = event.touches[0];
    if (!this.canStartSwipe(event, touch)) return;

    this.swipeTouchId = touch.identifier;
    this.swipeStartY = touch.clientY;
    this.swipeCurrentY = touch.clientY;
    this.swipeStartAt = Date.now();
    this.isSwiping = true;
    this.sheet.style.transition = "none";
  }

  handleSwipeMove(event) {
    if (!this.isSwiping || this.swipeTouchId == null) return;
    const touch = this.getTrackedTouch(event.touches);
    if (!touch) return;

    this.swipeCurrentY = touch.clientY;
    const deltaY = Math.max(0, this.swipeCurrentY - this.swipeStartY);
    if (deltaY <= 0) return;

    this.sheet.style.transform = `translateY(${deltaY}px)`;
    this.sheet.style.opacity = String(Math.max(0.7, 1 - Math.min(deltaY / 320, 0.3)));
    event.preventDefault();
  }

  handleSwipeEnd(event) {
    if (!this.isSwiping || this.swipeTouchId == null) return;

    const touch =
      this.getTrackedTouch(event.changedTouches || []) ||
      this.getTrackedTouch(event.touches || []);

    const endY = touch ? touch.clientY : this.swipeCurrentY;
    const distance = Math.max(0, endY - this.swipeStartY);
    const elapsed = Math.max(1, Date.now() - this.swipeStartAt);
    const velocity = distance / elapsed;
    const shouldClose =
      distance >= this.swipeCloseThresholdPx ||
      velocity >= this.swipeCloseVelocityThreshold;

    this.resetSwipeState();

    if (shouldClose) {
      this.clearSwipeStyles();
      this.close();
      return;
    }

    this.sheet.style.transition =
      "transform 220ms cubic-bezier(0.22, 1, 0.36, 1), opacity 220ms ease";
    this.sheet.style.transform = "";
    this.sheet.style.opacity = "";
    window.setTimeout(() => {
      this.clearSwipeStyles();
    }, 240);
  }

  open({ form, productHandle, productUrl = "" }) {
    this.ensureMounted();
    const normalizedHandle = productHandle || "";

    if (
      this.isOpen() &&
      this.currentOpenHandle &&
      normalizedHandle &&
      this.currentOpenHandle === normalizedHandle
    ) {
      this.close();
      return true;
    }

    this.activeForm = form;
    this.currentOpenHandle = normalizedHandle;
    this.manualMediaSrc = "";
    this.isAdding = false;

    this.show();
    this.renderLoadingState();

    if (!productHandle) {
      if (productUrl) {
        window.location.href = productUrl;
        return true;
      }

      this.setMessage("Unable to load options for this product.", "error");
      return true;
    }

    this.fetchProduct(productHandle)
      .then((product) => {
        if (this.currentOpenHandle !== productHandle) return;
        this.prepareProduct(product);
        this.render();
      })
      .catch((error) => {
        console.error(error);
        this.renderFetchError(productUrl);
      });

    return true;
  }

  show() {
    document.body.classList.add("mobile-variant-sheet-open");
    this.sheet.setAttribute("aria-hidden", "false");
  }

  close() {
    this.currentOpenHandle = "";
    this.isAdding = false;
    this.manualMediaSrc = "";
    this.resetSwipeState();
    this.clearSwipeStyles();
    document.body.classList.remove("mobile-variant-sheet-open");
    this.sheet.setAttribute("aria-hidden", "true");
    this.clearMessage();
  }

  renderLoadingState() {
    if (this.titleElement) this.titleElement.textContent = "Loading options";
    if (this.priceCurrentElement) this.priceCurrentElement.textContent = "";
    if (this.priceCompareElement) {
      this.priceCompareElement.textContent = "";
      this.priceCompareElement.hidden = true;
    }
    if (this.priceElement) this.priceElement.classList.remove("is-on-sale");
    if (this.optionsElement) {
      this.optionsElement.innerHTML =
        '<div class="mobile-variant-sheet__loading">Loading product options...</div>';
    }
    if (this.addButton) {
      this.addButton.disabled = true;
      this.addButton.textContent = "Add to cart";
    }
    this.clearMessage();
  }

  renderFetchError(productUrl) {
    if (this.optionsElement) {
      this.optionsElement.innerHTML =
        '<p class="mobile-variant-sheet__empty">We could not load options right now.</p>';
    }
    if (this.addButton) this.addButton.disabled = true;

    if (productUrl) {
      this.setMessage("Please open the product page to select options.", "hint");
    } else {
      this.setMessage("Please try again in a moment.", "error");
    }
  }

  fetchProduct(handle) {
    if (this.productCache.has(handle)) {
      return Promise.resolve(this.productCache.get(handle));
    }

    const root = window.Shopify?.routes?.root || "/";
    return fetch(`${root}products/${handle}.js`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch product: ${response.status}`);
        }
        return response.json();
      })
      .then((product) => {
        this.productCache.set(handle, product);
        return product;
      });
  }

  prepareProduct(product) {
    this.product = product;
    this.media = Array.isArray(product?.media) ? product.media : [];
    this.variants = (Array.isArray(product?.variants) ? product.variants : []).map((variant) => ({
      ...variant,
      _normalizedOptions: Array.isArray(variant?.options)
        ? variant.options.map((value, optionIndex) =>
            this.normalizeOptionText(value, `Option ${optionIndex + 1}`)
          )
        : [],
    }));
    const rawOptionNames = Array.isArray(product?.options) ? product.options : [];
    this.optionNames = rawOptionNames.map((optionName, index) =>
      this.normalizeOptionText(optionName, `Option ${index + 1}`)
    );
    this.optionValues = this.optionNames.map((_, index) => {
      const uniqueValues = new Set();
      this.variants.forEach((variant) => {
        const value = variant?._normalizedOptions?.[index];
        if (value) uniqueValues.add(value);
      });
      return this.sortOptionValues(this.optionNames[index], Array.from(uniqueValues));
    });

    this.sizeOptionIndex = this.optionNames.findIndex((optionName) =>
      this.isSizeOption(optionName)
    );

    this.selectedOptions = new Array(this.optionNames.length).fill(null);

    for (let index = 0; index < this.optionNames.length; index += 1) {
      if (index === this.sizeOptionIndex) continue;
      this.selectedOptions[index] = this.findFirstAvailableValue(index);
    }

    if (this.sizeOptionIndex < 0) {
      for (let index = 0; index < this.optionNames.length; index += 1) {
        if (!this.selectedOptions[index]) {
          this.selectedOptions[index] = this.findFirstAvailableValue(index);
        }
      }
    }

    this.selectedVariant = this.resolveSelectedVariant();
  }

  isSizeOption(optionName) {
    return String(optionName || "")
      .trim()
      .toLowerCase()
      .includes("size");
  }

  sortOptionValues(optionName, values) {
    if (!this.isSizeOption(optionName) || typeof getSortingSizes !== "function") {
      return values;
    }

    const sortingSizes = getSortingSizes();
    const sizeMap = new Map();

    sortingSizes.forEach((item, index) => {
      if (item?.size) sizeMap.set(String(item.size).toLowerCase(), index);
      if (item?.alias) sizeMap.set(String(item.alias).toLowerCase(), index);
    });

    return [...values].sort((a, b) => {
      const aIndex = sizeMap.get(String(a).toLowerCase());
      const bIndex = sizeMap.get(String(b).toLowerCase());

      if (aIndex == null && bIndex == null) {
        return String(a).localeCompare(String(b), undefined, { numeric: true });
      }
      if (aIndex == null) return 1;
      if (bIndex == null) return -1;
      return aIndex - bIndex;
    });
  }

  findFirstAvailableValue(index) {
    const values = this.optionValues[index] || [];
    for (const value of values) {
      if (this.isOptionValueAvailable(index, value)) {
        return value;
      }
    }
    return values[0] || null;
  }

  isOptionValueAvailable(index, value) {
    const nextSelection = [...this.selectedOptions];
    nextSelection[index] = value;

    return this.variants.some(
      (variant) =>
        variant.available &&
        variant._normalizedOptions.every(
          (variantOptionValue, optionIndex) =>
            nextSelection[optionIndex] == null ||
            nextSelection[optionIndex] === variantOptionValue
        )
    );
  }

  resolveSelectedVariant() {
    if (!this.selectedOptions.length) return null;
    if (this.selectedOptions.some((value) => value == null)) return null;

    return (
      this.variants.find(
        (variant) =>
          variant.available &&
          variant._normalizedOptions.every(
            (variantOptionValue, optionIndex) =>
              this.selectedOptions[optionIndex] === variantOptionValue
          )
      ) || null
    );
  }

  handleOptionSelect(index, value) {
    if (!this.isOptionValueAvailable(index, value)) return;

    this.clearMessage();
    this.manualMediaSrc = "";
    this.selectedOptions[index] = value;

    for (let optionIndex = index + 1; optionIndex < this.optionNames.length; optionIndex += 1) {
      const currentValue = this.selectedOptions[optionIndex];

      if (
        currentValue &&
        !this.isOptionValueAvailable(optionIndex, currentValue)
      ) {
        this.selectedOptions[optionIndex] = null;
      }

      if (optionIndex !== this.sizeOptionIndex && !this.selectedOptions[optionIndex]) {
        this.selectedOptions[optionIndex] = this.findFirstAvailableValue(optionIndex);
      }
    }

    this.selectedVariant = this.resolveSelectedVariant();
    this.render();
  }

  render() {
    if (!this.product) return;

    if (this.titleElement)
      this.titleElement.textContent = this.normalizeOptionText(
        this.product.title,
        "Select options"
      );

    this.renderPrice();
    this.renderMedia();

    if (this.optionsElement) {
      this.optionsElement.innerHTML = "";

      this.optionNames.forEach((optionName, index) => {
        const section = document.createElement("section");
        section.className = "mobile-variant-sheet__group";

        const heading = document.createElement("div");
        heading.className = "mobile-variant-sheet__group-head";

        const label = document.createElement("p");
        label.className = "mobile-variant-sheet__group-label";
        label.textContent = optionName;

        const selectedValueLabel = document.createElement("p");
        selectedValueLabel.className = "mobile-variant-sheet__group-value";
        selectedValueLabel.textContent = this.selectedOptions[index] || "-";

        heading.appendChild(label);
        heading.appendChild(selectedValueLabel);

        const valuesWrapper = document.createElement("div");
        valuesWrapper.className = "mobile-variant-sheet__values";

        (this.optionValues[index] || []).forEach((value) => {
          const valueButton = document.createElement("button");
          valueButton.type = "button";
          valueButton.className = "mobile-variant-sheet__value";
          valueButton.textContent = value;

          const isAvailable = this.isOptionValueAvailable(index, value);
          const isSelected = this.selectedOptions[index] === value;

          if (!isAvailable) {
            valueButton.classList.add("is-disabled");
            valueButton.disabled = true;
          }

          if (isSelected) {
            valueButton.classList.add("is-selected");
          }

          valueButton.addEventListener("click", () => this.handleOptionSelect(index, value));
          valuesWrapper.appendChild(valueButton);
        });

        section.appendChild(heading);
        section.appendChild(valuesWrapper);
        this.optionsElement.appendChild(section);
      });
    }

    this.updateAddButtonState();
  }

  renderPrice() {
    if (!this.priceElement || !this.priceCurrentElement || !this.priceCompareElement) return;

    const activePriceRaw = this.selectedVariant?.price ?? this.product?.price ?? 0;
    const compareRaw =
      this.selectedVariant?.compare_at_price ??
      this.product?.compare_at_price ??
      null;

    const activePrice = Number.isFinite(Number(activePriceRaw))
      ? Number(activePriceRaw)
      : 0;
    const comparePrice = Number.isFinite(Number(compareRaw)) ? Number(compareRaw) : null;
    const isOnSale = comparePrice != null && comparePrice > activePrice;

    this.priceCurrentElement.textContent = this.formatMoney(activePrice);
    this.priceCompareElement.textContent = isOnSale
      ? this.formatMoney(comparePrice)
      : "";
    this.priceCompareElement.hidden = !isOnSale;
    this.priceElement.classList.toggle("is-on-sale", isOnSale);
  }

  updateAddButtonState() {
    if (!this.addButton) return;

    let hint = "";

    if (this.sizeOptionIndex >= 0 && !this.selectedOptions[this.sizeOptionIndex]) {
      hint = "Select your size to continue.";
    } else if (this.selectedOptions.some((value) => value == null)) {
      hint = "Select options to continue.";
    } else if (!this.selectedVariant) {
      hint = "This combination is unavailable.";
    }

    this.addButton.textContent = this.isAdding ? "Adding..." : "Add to cart";
    this.addButton.disabled = Boolean(hint) || this.isAdding;

    if (!this.messageElement?.classList.contains("is-error")) {
      if (hint) {
        this.setMessage(hint, "hint");
      } else {
        this.clearMessage();
      }
    }
  }

  renderMedia() {
    if (!this.mediaMainElement || !this.mediaThumbsElement || !this.mediaSectionElement) return;

    const currentImageSrc = this.getCurrentImageSrc();
    const fallbackImage = this.media[0];
    const mainImageSrc = currentImageSrc || fallbackImage?.src || "";
    if (!mainImageSrc) {
      this.mediaSectionElement.hidden = true;
      return;
    }

    this.mediaSectionElement.hidden = false;
    const mainImageAlt =
      this.normalizeOptionText(this.product?.title, "Product image") || "Product image";

    this.mediaMainElement.src = mainImageSrc;
    this.mediaMainElement.alt = mainImageAlt;

    this.mediaThumbsElement.innerHTML = "";
    const mediaToRender = this.media.slice(0, 8);

    mediaToRender.forEach((mediaItem, index) => {
      const thumbSrc = mediaItem?.src;
      if (!thumbSrc) return;

      const thumbButton = document.createElement("button");
      thumbButton.type = "button";
      thumbButton.className = "mobile-variant-sheet__thumb";
      thumbButton.setAttribute("role", "listitem");
      thumbButton.setAttribute("aria-label", `Image ${index + 1}`);
      if (thumbSrc === mainImageSrc) {
        thumbButton.classList.add("is-active");
      }

      const thumbImage = document.createElement("img");
      thumbImage.src = thumbSrc;
      thumbImage.alt = "";
      thumbImage.loading = "lazy";
      thumbButton.appendChild(thumbImage);
      thumbButton.addEventListener("click", () => {
        this.manualMediaSrc = thumbSrc;
        this.renderMedia();
      });

      this.mediaThumbsElement.appendChild(thumbButton);
    });
  }

  getCurrentImageSrc() {
    if (this.manualMediaSrc) return this.manualMediaSrc;

    const selectedVariantImage = this.getVariantImageSrc(this.selectedVariant);
    if (selectedVariantImage) return selectedVariantImage;

    const partialVariantWithImage = this.variants.find(
      (variant) =>
        variant.available &&
        variant._normalizedOptions.every(
          (variantOptionValue, optionIndex) =>
            this.selectedOptions[optionIndex] == null ||
            this.selectedOptions[optionIndex] === variantOptionValue
        ) &&
        this.getVariantImageSrc(variant)
    );

    return (
      this.getVariantImageSrc(partialVariantWithImage) ||
      this.media[0]?.src ||
      ""
    );
  }

  getVariantImageSrc(variant) {
    if (!variant) return "";

    return (
      variant?.featured_image?.src ||
      variant?.featured_media?.preview_image?.src ||
      variant?.image?.src ||
      ""
    );
  }

  setMessage(message, tone = "hint") {
    if (!this.messageElement) return;

    if (!message) {
      this.clearMessage();
      return;
    }

    this.messageElement.hidden = false;
    this.messageElement.textContent = message;
    this.messageElement.classList.remove("is-hint", "is-error");
    if (tone === "error") {
      this.messageElement.classList.add("is-error");
    } else {
      this.messageElement.classList.add("is-hint");
    }
  }

  clearMessage() {
    if (!this.messageElement) return;
    this.messageElement.hidden = true;
    this.messageElement.textContent = "";
    this.messageElement.classList.remove("is-hint", "is-error");
  }

  handleAddToCart() {
    if (!this.selectedVariant || this.isAdding) return;

    this.isAdding = true;
    this.updateAddButtonState();

    postProductForm({
      id: this.selectedVariant.id,
      quantity: 1,
      sections_url: window.location.pathname,
    })
      .then((response) => {
        if (response.status) {
          this.setMessage(response.description || "Unable to add this item right now.", "error");
          return;
        }

        this.close();
        Sidecart.setAsVisible(response);
        if (this.activeForm && typeof this.activeForm.enterSuccessState === "function") {
          this.activeForm.enterSuccessState();
        }
      })
      .catch((error) => {
        console.error(error);
        this.setMessage("Something went wrong. Please try again.", "error");
      })
      .finally(() => {
        this.isAdding = false;
        if (document.body.classList.contains("mobile-variant-sheet-open")) {
          this.updateAddButtonState();
        }
      });
  }

  formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents);
    }

    const amount = Number(cents || 0) / 100;
    return `$${amount.toFixed(2)}`;
  }

  normalizeOptionText(value, fallback = "") {
    if (value == null) return fallback;

    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed || trimmed.toLowerCase() === "[object object]") return fallback;
      return trimmed;
    }

    if (typeof value === "number" || typeof value === "boolean") {
      return String(value);
    }

    if (Array.isArray(value)) {
      const fromArray = value
        .map((item) => this.normalizeOptionText(item, ""))
        .find((item) => item);
      return fromArray || fallback;
    }

    if (typeof value === "object") {
      const preferredKeys = [
        "name",
        "label",
        "title",
        "value",
        "text",
        "option",
      ];
      for (const key of preferredKeys) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          const resolved = this.normalizeOptionText(value[key], "");
          if (resolved) return resolved;
        }
      }

      const nestedResolved = Object.values(value)
        .map((nestedValue) => this.normalizeOptionText(nestedValue, ""))
        .find((resolvedValue) => resolvedValue);
      if (nestedResolved) return nestedResolved;

      return fallback;
    }

    return fallback;
  }
}

class BaseProductForm extends HTMLElement {
  constructor(options = {}) {
    super();
    this.listenClickOnly = Boolean(options.listenClickOnly);
    this.form = this.querySelector("form");
    this.cartNotification = document.querySelector("cart-notification");
    this.submitButton = this.querySelector('[type="submit"]');
    this.spinner = this.querySelector(".loading-overlay__spinner");
    this.resetTimer = 0;
    this.isSubmitting = false;
    this.mobileVariantPickerEnabled = this.dataset.mobileVariantPicker === "true";
    this.productHandle = this.dataset.productHandle || "";
    this.productUrl = this.dataset.productUrl || "";

    if (!this.form || !this.submitButton) return;

    this.usesEnhancedFeedback = this.submitButton.classList.contains(
      "button-add-to-cart"
    );
    buildAddToCartFeedback(this.submitButton);

    if (this.listenClickOnly) {
      this.submitButton.addEventListener("click", this.onSubmitHandler.bind(this));
    } else {
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.resetTimer) {
      window.clearTimeout(this.resetTimer);
      this.resetTimer = 0;
    }
  }

  static getMobileVariantSheet() {
    if (!window.__mobileVariantSheetInstance) {
      window.__mobileVariantSheetInstance = new MobileVariantSheet();
    }

    return window.__mobileVariantSheetInstance;
  }

  shouldOpenMobileVariantPicker() {
    if (!this.mobileVariantPickerEnabled) return false;
    return window.matchMedia("(max-width: 749px)").matches;
  }

  openMobileVariantPicker() {
    const sheet = BaseProductForm.getMobileVariantSheet();
    return sheet.open({
      form: this,
      productHandle: this.productHandle,
      productUrl: this.productUrl,
    });
  }

  scheduleReset(delayMs) {
    if (this.resetTimer) {
      window.clearTimeout(this.resetTimer);
    }

    this.resetTimer = window.setTimeout(() => {
      this.resetTimer = 0;
      clearAddToCartState(this.submitButton);
      if (this.spinner) this.spinner.classList.add("hidden");
      this.isSubmitting = false;
    }, delayMs);
  }

  enterLoadingState() {
    if (this.usesEnhancedFeedback) {
      setAddToCartState(this.submitButton, "atc-loading");
      if (this.spinner) this.spinner.classList.add("hidden");
      return;
    }

    setAddToCartState(this.submitButton, "loading");
    if (this.spinner) this.spinner.classList.remove("hidden");
  }

  enterSuccessState() {
    if (this.usesEnhancedFeedback) {
      setAddToCartState(this.submitButton, "atc-success");
      this.scheduleReset(950);
      return;
    }

    clearAddToCartState(this.submitButton);
    if (this.spinner) this.spinner.classList.add("hidden");
    this.isSubmitting = false;
  }

  enterErrorState() {
    if (this.usesEnhancedFeedback) {
      setAddToCartState(this.submitButton, "atc-error");
      this.scheduleReset(820);
      return;
    }

    clearAddToCartState(this.submitButton);
    if (this.spinner) this.spinner.classList.add("hidden");
    this.isSubmitting = false;
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    if (this.shouldOpenMobileVariantPicker() && this.openMobileVariantPicker()) {
      return;
    }

    if (!this.form || !this.submitButton || this.isSubmitting) return;
    if (
      this.submitButton.classList.contains("atc-loading") ||
      this.submitButton.classList.contains("atc-success")
    ) {
      return;
    }

    this.isSubmitting = true;
    this.handleErrorMessage();
    this.enterLoadingState();

    const payload = serializeProductFormPayload(this.form);

    postProductForm(payload)
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          this.enterErrorState();
          return;
        }

        Sidecart.setAsVisible(response);
        this.enterSuccessState();
      })
      .catch((error) => {
        console.error(error);
        this.handleErrorMessage("Something went wrong. Please try again.");
        this.enterErrorState();
      })
      .finally(() => {
        if (
          this.submitButton.classList.contains("atc-success") ||
          this.submitButton.classList.contains("atc-error")
        ) {
          return;
        }
        if (this.submitButton.classList.contains("atc-loading")) {
          return;
        }
        clearAddToCartState(this.submitButton);
        if (this.spinner) this.spinner.classList.add("hidden");
        this.isSubmitting = false;
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector(".product-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;

    this.errorMessage =
      this.errorMessage ||
      this.errorMessageWrapper.querySelector(".product-form__error-message");

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
    if (errorMessage && this.errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends BaseProductForm {
      constructor() {
        super();
      }
    }
  );
}

if (!customElements.get("product-form-2")) {
  customElements.define(
    "product-form-2",
    class ProductForm2 extends BaseProductForm {
      constructor() {
        super({ listenClickOnly: true });
      }
    }
  );
}
